
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  selector: 'FleetOverview',
  templateUrl: './FleetOverview.html',
})
export class FleetOverviewComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "FleetOverview");
    }
}
